/* LDC – Objectif panier 50 € + suggestions "petits plus"
   - Lit /cart.js, affiche la barre "plus que X €" dans chaque .ldc-goal
   - Suggère 3 produits de la collection "petits-plus" dont le prix comble l'écart
   - Se rafraîchit après tout appel /cart/add|change|update|clear (fetch intercepté) */
(function () {
  if (window.__ldcCartGoal) return;
  window.__ldcCartGoal = true;

  var LANG = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var T = {
    fr: { title: 'Pour compléter votre commande', ok: 'Minimum de commande atteint, votre panier est prêt.',
          left: function (r, m) { return 'Plus que <strong>' + r + '</strong> pour atteindre le minimum de commande de ' + m + '.'; },
          add: 'Ajouter',
          ship: 'Livraison réfrigérée en 1 à 3 jours en moyenne : Belgique et Luxembourg 17,90 €, France 27,90 €. Retrait gratuit à la boutique d\'Ixelles.' },
    nl: { title: 'Om uw bestelling aan te vullen', ok: 'Minimumbestelling bereikt, uw winkelmandje is klaar.',
          left: function (r, m) { return 'Nog <strong>' + r + '</strong> tot de minimumbestelling van ' + m + '.'; },
          add: 'Toevoegen',
          ship: 'Gekoelde levering in gemiddeld 1 tot 3 dagen: België en Luxemburg 17,90 €, Frankrijk 27,90 €. Gratis afhalen in de winkel in Elsene.' },
    en: { title: 'To complete your order', ok: 'Minimum order reached, your basket is ready.',
          left: function (r, m) { return 'Only <strong>' + r + '</strong> left to reach the minimum order of ' + m + '.'; },
          add: 'Add',
          ship: 'Refrigerated delivery in 1 to 3 days on average: Belgium and Luxembourg 17,90 €, France 27,90 €. Free collection from our Ixelles shop.' }
  };
  var L = T[LANG] || T.fr;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';


  var MARKUP = '<div class="ldc-goal" data-min="5000" data-collection="petits-plus" hidden>' +
    '<p class="ldc-goal__msg" data-goal-msg></p>' +
    '<div class="ldc-goal__bar" role="progressbar" aria-valuemin="0" aria-valuemax="50" aria-valuenow="0"><div class="ldc-goal__fill" data-goal-fill></div></div>' +
    '<p class="ldc-goal__title" data-goal-title hidden>' + L.title + '</p>' +
    '<ul class="ldc-goal__sug" data-goal-sug hidden></ul>' +
    '<p class="ldc-goal__ship" data-goal-ship>' + L.ship + '</p></div>';

  function mount() {
    // tiroir panier : au-dessus du sous-total ; page panier : au-dessus du bloc sous-total
    var targets = [
      document.querySelector('#offcanvas__mini_cart .cart_notification_links_inner'),
      document.querySelector('#main-cart-footer .cart__blocks')
    ];
    targets.forEach(function (el) {
      if (el && !el.querySelector('.ldc-goal') && !(el.previousElementSibling && el.previousElementSibling.classList && el.previousElementSibling.classList.contains('ldc-goal'))) {
        if (el.classList.contains('cart__blocks')) el.insertAdjacentHTML('beforebegin', MARKUP);
        else el.insertAdjacentHTML('afterbegin', MARKUP);
      }
    });
  }

  var products = null; // cache collection
  var loadingProducts = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function loadProducts(handle) {
    if (products) return Promise.resolve(products);
    if (loadingProducts) return loadingProducts;
    loadingProducts = fetch(ROOT + 'collections/' + handle + '/products.json?limit=50')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        products = (j.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return null;
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return {
            id: v.id,
            title: p.title,
            handle: p.handle,
            price: Math.round(parseFloat(v.price) * 100),
            image: img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2') : ''
          };
        }).filter(Boolean);
        return products;
      })
      .catch(function () { products = []; return products; });
    return loadingProducts;
  }

  function pick(list, remaining, inCartIds) {
    var candidates = list.filter(function (p) { return inCartIds.indexOf(p.id) === -1; });
    // d'abord le moins cher qui comble l'écart à lui seul, puis les suivants juste au-dessus
    var above = candidates.filter(function (p) { return p.price >= remaining; }).sort(function (a, b) { return a.price - b.price; });
    var below = candidates.filter(function (p) { return p.price < remaining; }).sort(function (a, b) { return b.price - a.price; });
    var out = above.slice(0, 2).concat(below.slice(0, 1));
    if (out.length < 3) out = out.concat(above.slice(2, 2 + (3 - out.length)));
    if (out.length < 3) out = out.concat(below.slice(1, 1 + (3 - out.length)));
    return out.slice(0, 3);
  }

  function render(cart) {
    var boxes = document.querySelectorAll('.ldc-goal');
    if (!boxes.length) return;
    boxes.forEach(function (box) {
      var min = parseInt(box.dataset.min, 10) || 5000;
      var total = cart.items_subtotal_price || cart.total_price || 0;
      var msg = box.querySelector('[data-goal-msg]');
      var fill = box.querySelector('[data-goal-fill]');
      var bar = box.querySelector('.ldc-goal__bar');
      var title = box.querySelector('[data-goal-title]');
      var sug = box.querySelector('[data-goal-sug]');
      if (title) title.textContent = L.title;
      if (!box.querySelector('[data-goal-ship]')) box.insertAdjacentHTML('beforeend', '<p class="ldc-goal__ship" data-goal-ship>' + L.ship + '</p>');

      if (!cart.item_count) { box.hidden = true; return; }
      box.hidden = false;
      var pct = Math.min(100, Math.round((total / min) * 100));
      fill.style.width = pct + '%';
      if (bar) bar.setAttribute('aria-valuenow', Math.min(50, Math.round(total / 100)));

      if (total >= min) {
        box.classList.add('ldc-goal--ok');
        msg.innerHTML = L.ok;
        title.hidden = true; sug.hidden = true; sug.innerHTML = '';
        return;
      }
      box.classList.remove('ldc-goal--ok');
      var remaining = min - total;
      msg.innerHTML = L.left(money(remaining), money(min));

      var inCart = cart.items.map(function (i) { return i.variant_id; });
      loadProducts(box.dataset.collection || 'petits-plus').then(function (list) {
        var picks = pick(list, remaining, inCart);
        if (!picks.length) { title.hidden = true; sug.hidden = true; return; }
        sug.innerHTML = picks.map(function (p) {
          return '<li class="ldc-goal__item">' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" width="44" height="44">' : '') +
            '<div class="ldc-goal__name"><a href="' + ROOT + 'products/' + p.handle + '">' + p.title + '</a><small>' + money(p.price) + '</small></div>' +
            '<button type="button" class="ldc-goal__add" data-variant="' + p.id + '">' + L.add + '</button></li>';
        }).join('');
        title.hidden = false; sug.hidden = false;
      });
    });
  }

  function refresh() {
    mount();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function addVariant(id, btn) {
    btn.disabled = true;
    var drawer = document.querySelector('cart-notification');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (document.body.classList.contains('template-cart') || /\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        }
        refresh();
      })
      .catch(function () { btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ldc-goal__add');
    if (!btn) return;
    e.preventDefault();
    addVariant(parseInt(btn.dataset.variant, 10), btn);
  });

  // Rafraîchir après toute modification du panier faite par le thème
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(u)) {
      p.then(function () { setTimeout(refresh, 150); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
